import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SignupUserService } from '@app/modules/signup-new/services/signup-user.service';
import { SignupWizardService } from '@app/modules/signup-new/services/signup-wizard.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'sbnb-signup-password-page',
  templateUrl: './signup-password-page.component.html',
})
export class SignupPasswordPageComponent {
  loading = false;
  showPasswordHints = false;

  validationMessages = [
    {
      key: 'minlength',
      message: 'Must be at least 8 characters',
    },
    {
      key: 'hasNumber',
      message: 'Must contain at least 1 number',
    },
    {
      key: 'hasMixedCase',
      message: 'Must contain upper and lowercase letters',
    },
  ];

  form = new UntypedFormGroup(
    {
      password: new UntypedFormControl('', [Validators.required]),
      confirm: new UntypedFormControl('', [Validators.required]),
    },
    {
      validators: (group) => {
        const password = group.get('password').value;
        const confirm = group.get('confirm').value;

        const passwordErrors = {
          minlength: password?.length < 8,
          hasNumber: !password?.match(/.*\d.*/),
          hasMixedCase: !password?.match(/(?=.*[a-z])(?=.*[A-Z])/),
        };

        group.get('password').setErrors(Object.values(passwordErrors).some(Boolean) ? passwordErrors : null);

        group.get('confirm').setErrors(password !== confirm ? { mismatch: true } : null);

        return null;
      },
    }
  );

  constructor(
    private signupWizardService: SignupWizardService,
    private signupUserService: SignupUserService
  ) {}

  onContinue() {
    if (!this.form.valid) return;

    this.loading = true;
    this.signupUserService
      .updatePassword({
        password: this.form.controls.password.value,
        password_confirmation: this.form.controls.confirm.value,
      })
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(() => this.signupWizardService.next('password'));
  }
}
